import { render, staticRenderFns } from "./AppSplash.vue?vue&type=template&id=b6af5d26&scoped=true"
import script from "./AppSplash.vue?vue&type=script&lang=js"
export * from "./AppSplash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6af5d26",
  null
  
)

export default component.exports